<template>
    <div :id="`${id}_cont`" class="form-group pb-2" v-if="showContent">
        <template v-if="!editMode">
            <div class="d-flex justify-content-between">
                <div class="d-flex">
                    <label v-if="title" :for="id" class="title form-label">{{ title }}</label>
                    <template v-if="moreInfo" >
                        <p :title="moreInfoText" class="m-0">
                            <i class="ri-information-2-line"></i>
                        </p>           
                    </template>
                    <p class="invalid-feedback required ps-2" v-if="asterisk"> * </p>
                </div>                
                <template v-if="errorMsgForm">
                    <p class="invalid-feedback">
                        {{ errorMsgForm }}
                    </p>
                </template>
                <template v-else-if="!disableValidation && (feedback === 'invalid' || feedback === 'valid')">
                    <p v-if="feedback === 'invalid'" class="invalid-feedback">
                        {{ errorMsg }}
                    </p>
                    <p v-else-if="feedback === 'valid'" class="valid-feedback">
                        {{ validMsg }}
                    </p>
                </template>
                <template v-else-if="isRequired && !onlyFile">
                    <p class="invalid-feedback required">
                        Dato obligatorio
                    </p>
                </template>
                <template v-else-if="!isRequired && !onlyFile">
                    <p class="invalid-feedback optional">
                        Dato opcional
                    </p>
                </template>
            </div>
        </template>
        <template v-else-if="editMode">
            <div class="d-flex">
                <label v-if="title" :for="id" class="title">{{ title }}</label>
                <template v-if="isRequired && !errorMsgForm && editMode">
                    <p class="invalid-feedback required ms-1">*</p>
                </template>
            </div>
        </template>
        <div class="dropzone form-control" :class="{ 'border-green-valid': feedback === 'valid' }">
            <!-- @change="handleChange($event.target.value)" -->
            <p class="fake-btn text-center">Clickea aquí para seleccionar el archivo{{ multiple ? 's' : '' }}</p>
            <template v-if="onlyFile">
                <p class="file-msg">o arrástralo y suéltalo aquí (.xlsx)</p>
                <p class="file-msg">Tamaño máximo: 5MB.</p>
                <input ref="fileInput" class="file-input" name="file" type="file" :multiple="multiple" :id="id"
                    @change="$emit('update:modelValue', $event.target.files)" accept=".xlsx" :required="isRequired">
            </template>
            <template v-else>
                <div id="previewImage_cont" ref="previewImage_cont" class="d-none">
                    <img ref="previewImage" class="preview-image col-12" />
                </div>
                <p class="file-msg">
                    o arrástral{{ multiple ? 'os' : 'o' }} y suélt{{ multiple ? 'alos' : 'alo' }} aquí
                    ({{ iconFormat ? '.svg,.png' : '.jpg,.jpeg,.png' }})
                </p>
                <p class="file-msg">Tamaño máximo: {{ multiple ? '5 MB por archivo' : '2 MB' }}.</p>
                <input ref="fileInput2" class="file-input" name="file" type="file" :multiple="multiple" :id="id"
                    @change="$emit('update:modelValue', $event.target.files)" :accept="iconFormat ? '.svg,.png' : '.jpg,.jpeg,.png'"
                    :required="isRequired">
            </template>
        </div>
    </div>
    <!-- Loading -->
    <div :id="`${id}_cont`" v-else>
        <div class="form-group pb-2">
            <label v-if="title" class="title placeholder-glow col-3">
                <span class="placeholder col-12"></span>
            </label>
            <div class="placeholder-glow col-12">
                <div class="dropzone form-control placeholder col-12"></div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';

export default {
    name: "VsudDropZone",
    props: {
        id: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "",
        },
        multiple: {
            type: String,
            default: "",
        },
        errorMsg: {
            type: String,
            default: 'Valor incorrecto o nulo',
        },
        errorMsgForm: {
            type: String,
            default: '',
        },
        validMsg: {
            type: String,
            default: 'Completado correctamente',
        },
        isRequired: Boolean,
        modelValue: {
            type: String,
            default: " "
        },
        disableValidation: {
            type: Boolean,
            default: false,
        },
        editMode: {
            type: Boolean,
            default: false,
        },
        onlyFile: {
            type: Boolean,
            default: false,
        },
        moreInfo: {
            type: Boolean,
            default: false,
        },
        moreInfoText: {
            type: String,
        },
        iconFormat: {
            type: Boolean,
            default: false,
        },
        asterisk: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            showContent: false,
            minLoadTime: 1500,
            loadStart: null,
            feedback: 'invalid',
        };
    },
    mounted() {
        this.loadStart = Date.now();
        window.addEventListener("load", this.onLoad);
        setTimeout(() => {
            this.showContent = true;
        }, this.minLoadTime);

        if (this.modelValue == "") {
            this.feedback = "null";
        }

    },
    watch: {
        modelValue(newVal) {
            if (newVal == "" && this.isRequired) {
                this.feedback = "invalid";
                this.$emit("feedback", this.feedback);
            }
        },
    },
    updated() {
        var fileInput = $('.file-input');
        const textContainer = fileInput.prev();

        if (!this.onlyFile) {
            var droparea = $('.dropzone');

            fileInput.on('dragenter focus click', function () {
                droparea.addClass('is-active');
            });

            fileInput.on('dragleave blur drop', function () {
                droparea.removeClass('is-active');
            });

            fileInput.on('change', (event) => {
                var filesCount = event.target.files.length;
                var textContainer = $(event.target).prev();
                var isValidSize = true;
                var isValidCount = true;

                // Validar tamaño de archivos
                for (const file of event.target.files) {
                    if (file.size > (this.multiple ? 5 * 1024 * 1024 : 3 * 1024 * 1024)) {
                        isValidSize = false;
                        break;
                    }
                }

                // Validar cantidad de archivos
                if ((this.multiple && filesCount > 5) || (!this.multiple && filesCount > 1)) {
                    isValidCount = false;
                }

                if (!isValidSize || !isValidCount) {
                    this.feedback = "invalid";
                    textContainer.text('Archivo no válido');
                    event.target.value = '';
                } else if (filesCount === 1) {
                    var fileName = $(event.target).val().split('\\').pop();
                    textContainer.text(this.shortenString(fileName))
                    this.handleChange(event)
                } else {
                    textContainer.text(filesCount + ' archivos seleccionados');
                }
            });
        } else {
            fileInput.on('change', (event) => {

                const file = event.target.files[0];
                const isValidSize = this.validateFileSize(file);
                const isValidType = this.validateFileType(file);

                if (!isValidSize || !isValidType) {
                    this.feedback = "invalid";
                    textContainer.text('Archivo no válido');
                    event.target.value = '';
                } else {
                    this.feedback = "valid";
                    const fileName = file ? file.name : '';
                    textContainer.text(fileName);
                }
            });
        }

        this.$emit("feedback", this.feedback);
    },
    beforeUnmount() {
        window.removeEventListener("load", this.onLoad);
    },
    methods: {
        clearInput() {
            if (this.$refs.fileInput) {
                this.$refs.fileInput.value = "";
            }

            if (this.$refs.fileInput2) {
                this.$refs.fileInput2.value = "";
            }

            var fileInput = $('.file-input');
            const textContainer = fileInput.prev();
            textContainer.text('Tamaño máximo: 5MB.');

            this.$emit('update:modelValue', null);
            this.feedback = null
        },
        validateFileType(file) {
            if (file) {
                // Permitir todos los tipos de archivo relacionados con Excel
                const allowedExtensions = ['xlsx'];
                const fileExtension = file.name.split('.').pop().toLowerCase();
                return allowedExtensions.some(ext => fileExtension === ext);
            }
            return false
        },
        validateFileSize(file) {
            if (file) {
                const maxFileSize = 5 * 1024 * 1024;
                return file.size <= maxFileSize;
            }
            return false
        },
        onLoad() {
            const loadTime = Date.now() - this.loadStart;
            if (loadTime >= this.minLoadTime) {
                this.showContent = true;
            } else {
                setTimeout(() => {
                    this.showContent = true;
                }, this.minLoadTime - loadTime);
            }
        },
        handleChange(event) {
            const input = event.target;
            const previewImage = this.$refs.previewImage;
            const previewImage_cont = this.$refs.previewImage_cont;

            if (previewImage && previewImage_cont) {
                if (input.files && input.files[0]) {
                    const file = input.files[0];
                    const allowedExtensions = ['jpg', 'jpeg', 'png', 'svg'];
                    const fileExtension = file.name.split('.').pop().toLowerCase();

                    if (allowedExtensions.includes(fileExtension)) {
                        const reader = new FileReader();
                        reader.onload = (e) => {
                            previewImage.src = e.target.result;
                            previewImage_cont.classList.remove('d-none');
                            previewImage_cont.classList.add('d-flex');
                        }
                        reader.readAsDataURL(file);
                    } else {
                        previewImage.src = '';
                        previewImage_cont.classList.add('d-none');
                    }
                } else {
                    previewImage.src = '';
                    previewImage_cont.classList.add('d-none');
                }
            }
        },
        shortenString(str) {
            let maxLength;
            const windowWidth = window.innerWidth;

            if (windowWidth >= 1700) {
                maxLength = 90;
            } else if (windowWidth >= 1500) {
                maxLength = 75;
            } else if (windowWidth < 1500) {
                maxLength = 50;
            }

            if (str && str.length > maxLength) {
                return str.slice(0, maxLength) + '...';
            }
            return str;
        },
    },
};
</script>

<style scoped>
.optional {
    color: var(--gray-text);
}

.title {
    color: var(--black);
    font-size: 0.9rem;
    font-weight: 500;
}

.dropzone {
    height: 145px;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: 100%;
    padding: 25px;
    transition: 0.2s;
    overflow: hidden;
}

.dropzone.is-active {
    background-color: var(--hover-gray);
}

.fake-btn {
    flex-shrink: 0;
    border-radius: 3px;
    padding: 8px 15px;
    margin: 0;
    font-size: 12px;
    text-transform: uppercase;
}

.file-msg {
    font-size: small;
    font-weight: 300;
    line-height: 1.4;
    white-space: nowrap;
    /* overflow: hidden; */
    text-overflow: ellipsis;
    margin-bottom: 0.5rem;
}

.file-input {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    cursor: pointer;
    opacity: 0;
    height: 145px;
}

.file-input:focus {
    outline: none;
}

.border-red-invalid .dropzone {
    border: 1px solid #fd5c70;
}

.border-red-invalid .dropzone {
    border-color: #fd5c70;
    padding-right: unset;
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23fd5c70' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23fd5c70' stroke='none'/%3e%3c/svg%3e") !important;
    background-repeat: no-repeat !important;
    background-position: right 0.75rem top 0.7rem !important;
    background-size: 1.05rem 1.05rem !important;
}

.border-red-invalid .dropzone.border-green-valid,
.border-green-valid {
    border-color: #66d432;
    padding-right: unset;
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 10 8'%3e%3cpath fill='%2366d432' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e") !important;
    background-repeat: no-repeat !important;
    background-position: right 0.75rem top 0.7rem !important;
    background-size: 1.05rem 1.05rem !important;
}

.preview-image {
    max-height: calc(145px - 105px);
    margin-bottom: 8px;
    border-radius: 4px;
    border: 1px solid var(--light-gray);
}

#previewImage_cont {
    position: relative;
    z-index: 2;
    transition: transform 0.4s ease-out;
}

#previewImage_cont:hover {
    transform: scale(328%);
    top: 23px;
}

#previewImage_cont:hover .preview-image {
    border: none;
}

.dropzone.form-control {
    padding: 25px !important;
}
.ri-information-2-line{
  color: var(--blue);
  position: relative;
  bottom: 3px;
  padding-left: 0.3rem;
  cursor: pointer;
}
</style>
